import React from "react";
import { Clock, Video, ShieldCheck } from "lucide-react";

const STEPS = [
  { icon: Clock, title: "Quote in 24 hours", note: "We review every submission within one business day." },
  { icon: Video, title: "Free video chat", note: "Jump on a call with the engraver if the design needs clarification." },
  { icon: ShieldCheck, title: "Card on file via Stripe", note: "Saved after you receive the quote — only charged once you approve." },
];

export function QuoteProcess() {
  return (
    <div data-testid="quote-process" className="mt-8 grid sm:grid-cols-3 gap-4">
      {STEPS.map(({ icon: Icon, title, note }) => (
        <div key={title} className="rounded-lg border hairline p-4 bg-white flex items-start gap-3">
          <Icon size={18} strokeWidth={1.75} style={{color: "var(--accent-metal)"}} className="mt-0.5 shrink-0"/>
          <div><div className="text-sm font-semibold" style={{color: "var(--primary)"}}>{title}</div>
          <div className="text-xs text-[color:var(--text-muted)] mt-1">{note}</div></div>
        </div>
      ))}
    </div>
  );
}
